<template>
  <div>
    <router-view />
    <RemoveWorkspaceDialogConfirmation />
    <div class="snackbar-container">
      <div
        class="snackbar"
        :class="{
          info: snackbar.type === 'info',
          fail: snackbar.type === 'fail',
          success: snackbar.type === 'success',
        }"
        v-for="(snackbar, index) in snackbars"
        :key="`snackbar-${index}`"
      >
        {{ snackbar.data }}
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from './EventBus';
import RemoveWorkspaceDialogConfirmation from '@/components/settings/RemoveWorkspaceDialogConfirmation.vue';

export default {
  components: {
    RemoveWorkspaceDialogConfirmation,
  },
  data: function() {
    return {
      currentActive: 0,
      snackbars: [],
    };
  },
  mounted: function() {
    let self = this;

    EventBus.$on('show-snackbar', function(text) {
      var found = self.snackbars.find(function(item) {
        return item.data === text;
      });
      if (!found) {
        self.snackbars.push({ type: 'error', data: text });
        setTimeout(function() {
          self.snackbars.shift();
        }, 5000);
      }
    });

    EventBus.$on('show-info', function(text) {
      self.snackbars.push({ type: 'info', data: text });
      setTimeout(function() {
        self.snackbars.shift();
      }, 5000);
    });
    EventBus.$on('show-success', function(text) {
      self.snackbars.push({ type: 'success', data: text });
      setTimeout(function() {
        self.snackbars.shift();
      }, 5000);
    });
    EventBus.$on('show-fail', function(text) {
      self.snackbars.push({ type: 'fail', data: text });
      setTimeout(function() {
        self.snackbars.shift();
      }, 5000);
    });
  },
};
</script>

<style lang="scss">
@import 'assets/fonts/style.css';
@import 'styles/general';
@import 'styles/auth-styles';
@import 'styles/selects';
@import 'styles/loaders';
@import 'styles/state-circle';
@import 'styles/inputs';
@import 'styles/page-header';
@import 'styles/buttons';
@import 'styles/pagination';
@import 'styles/tabs';
@import 'styles/logs';
@import 'styles/tables';
@import 'styles/dialog';
@import 'styles/datepicker';
@import 'styles/tooltips';
@import 'styles/accordions';
@import 'styles/lists';
@import 'styles/radio-buttons';
@import 'styles/switch';
@import 'styles/checkbox';
@import 'styles/os';
@import 'styles/sliders';
@import 'styles/small-loader';
@import 'styles/scrollbar';
@import 'styles/summary';

.snackbar {
  position: fixed;
  right: 15px;
  bottom: 15px;
  width: 500px;
  z-index: 100000;
  background: #f00;
  color: #fff;
  padding: 15px;
  margin-bottom: 10px;
  word-break: break-word;
  white-space: pre-line;
  line-height: 24px;
  &.info {
    background: #009cf2;
  }
  &.fail {
    background: #f00;
  }
  &.success {
    background: #4bb543;
  }
}

.list-enter-active,
.list-leave-active {
  transition: all 1s;
}
.list-enter,
.list-leave-to {
  opacity: 0;
}
</style>
